import ProfileEdit from './ProfileEdit'

export default ProfileEdit
// eslint-disable-next-line import/export
export * from './ProfileEdit'
